import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';

import { MenuItems,StaffMenuItems,BRANCHmenuITEMS,Docmenuitems } from './menu-items/menu-items';
import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from './accordion';
import { ToggleFullscreenDirective } from './fullscreen/toggle-fullscreen.directive';
import {CardRefreshDirective} from './card/card-refresh.directive';
import {CardToggleDirective} from './card/card-toggle.directive';
import { CardComponent } from './card/card.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ParentRemoveDirective} from './elements/parent-remove.directive';
import {PaginationModule} from 'ngx-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SpinnerComponent} from '../spinner/spinner.component';
//import {GoTopButtonModule} from 'ng2-go-top-button';
import {ScrollModule} from '../scroll/scroll.module';
import {ToastyModule} from 'ng2-toasty';
import {SimpleNotificationsModule} from 'angular2-notifications';
import {TagInputModule} from 'ngx-chips';
 //import { ExportAsModule } from 'ngx-export-as';
 //import {AgmCoreModule} from '@agm/core';
import {Ng2GoogleChartsModule} from 'ng2-google-charts';
import {ClickOutsideModule} from 'ng-click-outside';
import { FilterPipe } from '../pipes/filter.pipe';


@NgModule({
  imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      NgbModule.forRoot(),
      PaginationModule.forRoot(),
      ScrollModule,
      ToastyModule.forRoot(),
      SimpleNotificationsModule.forRoot(),
      TagInputModule,
    //  AgmCoreModule,
    //   Ng2GoogleChartsModule,
      ClickOutsideModule,
    //  GoTopButtonModule,
      //ExportAsModule
  ],
  declarations: [
      AccordionAnchorDirective,
      AccordionLinkDirective,
      AccordionDirective,
      ToggleFullscreenDirective,
      CardRefreshDirective,
      CardToggleDirective,
      ParentRemoveDirective,
      CardComponent,
      SpinnerComponent,FilterPipe
  ],
  exports: [
      AccordionAnchorDirective,
      AccordionLinkDirective,
      AccordionDirective,
      ToggleFullscreenDirective,
      CardRefreshDirective,
      CardToggleDirective,
      ParentRemoveDirective,
      CardComponent,
      SpinnerComponent,
      NgbModule,
      PaginationModule,
      FormsModule,
      ReactiveFormsModule,
      ScrollModule,
      ToastyModule,
      SimpleNotificationsModule,
      TagInputModule,
    // AgmCoreModule,
      Ng2GoogleChartsModule,
      ClickOutsideModule,
     // GoTopButtonModule,
      FilterPipe
  ],
  providers: [
     MenuItems,StaffMenuItems,BRANCHmenuITEMS,Docmenuitems,
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// D:/Angular projects/memberreg/memberreg/src/app/shared/shared.module.ts